import { DEFAULT_ZIP_CODE } from 'modules/shipping/constants'

export default function isValidZipCodeShippingUtil (zipCode) {
  return zipCode && zipCode !== DEFAULT_ZIP_CODE
}
